import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';

import AdvancedHotkey from './component';
import { createBatchWithFulfillmentPlans } from '../../../store/batches/batches.actions';
import Global from '../../../store/global-selectors';

export const messages = defineMessages({
  name: {
    description: 'create new batch hotkey',
    defaultMessage: 'Create new batch',
    id: 'LmUYUy',
  },
});

export const hotkey = ['b'];
export const barcodeContent = '+648DB7927BC9=';

const CreateBatchHotkey = ({ children }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const name = '';
  const userId = useSelector(Global.selectUserCurrentUserId);
  const onUpdate = useCallback(() => {
    dispatch(createBatchWithFulfillmentPlans(name, userId, []));
  }, [dispatch, userId]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
      isGlobal: true,
    }),
    [intl, onUpdate],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

CreateBatchHotkey.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CreateBatchHotkey;
